import { t } from "@/i18n-js/instance";
import { PRICE_SCENARIOS } from "@circle-react/helpers/paywallPriceHelpers";
import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";
import { shouldExpandFirstPayment } from "../variants/helpers";

export const PaidTrialLine = ({ preview, options }: ComponentLineProps) => {
  if (
    shouldExpandFirstPayment(preview) ||
    ![PRICE_SCENARIOS.upfrontThenTrialThenValue].includes(
      preview.preview_scenario,
    )
  ) {
    return null;
  }

  return (
    <DefaultFullPreview.PreviewEntry
      label={t("paywall_checkout.first_payment.total_due_for_paid_trial", {
        count: preview?.trial_period?.days,
      })}
      value={preview.formatted_amount_due_now}
      valueWeight="semibold"
      dataTestId="checkout-form-preview-today-payment-paid-trial"
      {...options}
    />
  );
};
